const f = {
  color: {
    background: "#ffffffff",
    border: "#dfe6ebff",
    note: {
      text: "#fff6e5ff",
      background: "#574323ff"
    }
  }
};
export {
  f as toolbar
};
